import React from 'react';
import propTypes from 'prop-types';

export const CustomerClubIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 490 490"
      enableBackground="new 0 0 490 490"
      // style="enable-background:new 0 0 490 490;"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M188.297,56.793c0,31.317,25.388,56.704,56.705,56.704c31.317,0,56.705-25.388,56.705-56.704
     c0-31.317-25.388-56.705-56.705-56.705C213.685,0.088,188.297,25.476,188.297,56.793z M286.401,56.793
     c0,22.827-18.571,41.397-41.398,41.397c-22.827,0-41.398-18.57-41.398-41.397c0-22.827,18.571-41.398,41.398-41.398
     C267.829,15.395,286.401,33.967,286.401,56.793z"
        />
        <path
          d="M130.06,180.165c0,52.873,0,65.133,0,65.133s111.875,0,112.26,0l-54.789-118.773
     C187.531,126.525,130.06,127.291,130.06,180.165z M145.367,229.991v-49.826c0-5.694,1.705-32.17,32.779-37.443l40.257,87.27
     H145.367z"
        />
        <path
          d="M359.945,180.165c0-52.874-57.471-53.64-57.471-53.64l-54.789,118.773h112.26
     C359.945,245.298,359.945,233.038,359.945,180.165z M344.638,229.991h-73.035l40.184-87.113
     c12.635,2.438,32.852,10.523,32.852,37.286V229.991z"
        />
        <polygon points="245.002,126.525 205.539,126.525 245.002,213.881 284.466,126.525 	" />
        <path
          d="M485.509,225.463l-7.713,1.883c-26.982,6.562-29.074,24.007-31.481,44.217c-1.256,10.404-2.661,22.198-7.145,36.19
     c-4.813,14.948-15.068,25.636-25.801,33.11c6.218-7.833,12.512-17.011,17.773-27.266c6.129-11.929,6.592-21.211,1.375-27.594
     c-8.715-10.703-28.476-5.875-32.333-4.798l-2.586,0.733l-1.57,2.138c-0.179,0.269-19.926,26.787-86.64,73.56
     c-73.68,51.646-35.965,127.359-35.562,128.121l2.123,4.156h67.207l0.389-7.235c1.659-30.734,26.533-49.09,58.029-72.319
     c15.711-11.585,33.514-24.724,50.211-40.973c52.139-50.779,36.025-132.68,35.323-136.148L485.509,225.463z M441.113,358.412
     c-15.95,15.531-32.572,27.789-48.627,39.628c-31.182,23.005-58.388,43.081-63.485,76.565h-43.44
     c-6.114-14.948-21.72-66.355,32.617-104.443c58.747-41.182,82.156-67.118,88.434-74.771c6.458-1.375,12.945-1.076,14.051,0.284
     c0.015,0.015,1.166,2.556-3.124,10.927c-15.576,30.3-41.855,51.063-42.124,51.258l-25.666,20.075l31.914-6.532
     c2.317-0.478,57.042-12.198,72.08-58.971c4.933-15.397,6.502-28.521,7.758-39.06c1.898-15.905,2.84-23.783,11.884-28.357
     C475.838,266.406,478.05,322.432,441.113,358.412z"
        />
        <path
          d="M180.61,357.635c-66.714-46.773-86.446-73.291-86.625-73.545l-1.585-2.182l-2.571-0.703
     c-3.857-1.076-23.618-5.905-32.348,4.798c-5.202,6.398-4.739,15.681,1.39,27.594c5.262,10.255,11.555,19.433,17.773,27.266
     c-10.733-7.474-21.002-18.162-25.801-33.11c-4.499-14.007-5.904-25.801-7.145-36.205c-2.422-20.195-4.499-37.64-31.496-44.202
     l-7.713-1.883l-1.599,7.773c-0.703,3.468-16.817,85.369,35.338,136.148c16.697,16.249,34.5,29.388,50.211,40.973
     c31.496,23.229,56.37,41.586,58.029,72.319l0.389,7.235h67.192l2.123-4.156C216.561,484.994,254.305,409.281,180.61,357.635z
      M204.408,474.605h-43.395c-5.112-33.499-32.303-53.56-63.485-76.565c-16.069-11.839-32.677-24.096-48.627-39.628
     c-36.847-35.876-34.695-91.976-32.273-113.397c9.029,4.589,9.971,12.452,11.869,28.357c1.256,10.539,2.825,23.648,7.773,39.06
     c15.008,46.773,69.763,58.492,72.08,58.971l32.064,6.562l-25.816-20.105c-0.269-0.209-26.488-20.838-42.124-51.258
     c-4.305-8.386-3.139-10.912-3.124-10.927c1.121-1.36,7.579-1.659,14.051-0.284c6.278,7.654,29.672,33.589,88.419,74.771
     C225.933,408.085,210.477,459.612,204.408,474.605z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
CustomerClubIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
CustomerClubIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
